import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=e36ba7d2"
import script from "./AlertsView.vue?vue&type=script&lang=js"
export * from "./AlertsView.vue?vue&type=script&lang=js"
import style0 from "./AlertsView.vue?vue&type=style&index=0&id=e36ba7d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports